<mat-dialog-content>
	<form
		[formGroup]="group"
		class="flex flex-auto flex-col space-y-2"
	>
		<div
			*ngIf="user.value$ | async as user"
			class="flex items-start space-x-3 pb-4"
		>
			<app-user-avatar
				[userId]="user.id"
				class="mat-elevation-z3 rounded-lg"
				size="56px"
			></app-user-avatar>
			<div class="flex flex-col space-y-1 flex-auto align-center">
				<div>{{ user.name }}</div>
				<div
					*ngIf="user.email as mail"
					class="mat-hint"
				>
					{{ mail }}
				</div>
				<div
					*ngIf="user.staff_number as staffId"
					class="mat-hint"
				>
					{{ staffId }}
				</div>
			</div>
			<div class="flex items-center space-x-2 h-[56px]">
				<mat-slide-toggle
					(change)="onLicenseToggle($event)"
					[checked]="group.controls.has_license.value"
					[disabled]="!(isAdmin$.value$ | async) || user.removed || (workspaceStatus$ | async)?.isTrial || (isLoading.value$ | async) || isCurrentUser"
					[matTooltip]="'workspace.license' | translate"
					color="primary"
				></mat-slide-toggle>
				<div
					[matTooltip]="'user.deactivate' | translate"
					*ngIf="!user.removed"
				>
					<button
						(click)="removeUser(user)"
						[disabled]="!(isAdmin$.value$ | async) || (isLoading.value$ | async) || isCurrentUser"
						mat-icon-button
					>
						<mat-icon>delete</mat-icon>
					</button>
				</div>
			</div>
		</div>
		<mat-tab-group
			(selectedIndexChange)="selectedTabIndex.next($event)"
			[selectedIndex]="selectedTabIndex.value$ | async"
			class="mat-tab-flex flex-auto"
		>
			<mat-tab>
				<ng-template mat-tab-label>
					<div class="flex items-center space-x-2">
						<mat-icon>account_circle</mat-icon>
						<span>{{ 'workspace.user.userInfoTab' | translate }}</span>
					</div>
				</ng-template>
				<div class="flex flex-col mt-4">
					<div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
						<mat-form-field
							appearance="fill"
							class="relative"
							floatLabel="always"
						>
							<mat-label>{{ 'workspace.laborcosts.value' | translate }}</mat-label>
							<input
								[options]="{ prefix: (currency$ | async) + ' ' }"
								currencyMask
								formControlName="labor_cost"
								matInput
								type="text"
							>
							<div
								[matTooltip]="'workspace.laborcosts.tooltip' | translate"
								class="mat-hint"
								matSuffix
							>
								<mat-icon inline>info</mat-icon>
							</div>
						</mat-form-field>
						<mat-form-field
							*ngIf="projecthoursEnabled$ | async"
							appearance="fill"
							class="relative"
							floatLabel="always"
						>
							<mat-label>{{ 'workspace.hourlyrates.value' | translate }}</mat-label>
							<input
								[options]="{ prefix: (currency$ | async) + ' ' }"
								currencyMask
								formControlName="billable_rate"
								matInput
								type="text"
							>
							<div
								[matTooltip]="'workspace.hourlyrates.tooltip' | translate"
								class="mat-hint"
								matSuffix
							>
								<mat-icon inline>info</mat-icon>
							</div>
						</mat-form-field>
					</div>
					<mat-form-field appearance="fill">
						<mat-label>{{ 'workspace.user.staffId' | translate }}</mat-label>
						<input
							formControlName="staff_number"
							matInput
							type="text"
						>
					</mat-form-field>
					<div class="flex flex-col space-y-4">
						<ng-container *ngTemplateOutlet="groupsTemplate"></ng-container>
						@if (comegoEnabled$ | async) {<ng-container
							*ngTemplateOutlet="subordinateTemplate"
						></ng-container>
						<ng-container *ngTemplateOutlet="supervisorTemplate"></ng-container>}
					</div>
				</div>
			</mat-tab>
			@if( scheduleEnabled$ | async ) {
			<mat-tab>
				<ng-template mat-tab-label>
					<div class="flex items-center space-x-2">
						<mat-icon>schedule</mat-icon>
						<span>{{ 'workspace.schedule.userSchedule' | translate }}</span>
					</div>
				</ng-template>
				<div class="mt-4 flex flex-col space-y-3">
					<ng-container *ngTemplateOutlet="isWorkspaceInheritance && workspaceScheduleInherit"></ng-container>
					<button
						(click)="addSchedule()"
						[disabled]="group.disabled"
						class="h-12"
						mat-button
					>
						{{ 'schedules.create' | translate }}
					</button>
					<ng-container *ngFor="let ctrl of group.controls.schedules.controls; let i = index">
						<div
							[ngClass]="{ 'mat-bg-2 shadow-lg': s.isPrimary }"
							*ngIf="{ isPrimary: isCurrentSchedule(i) } as s"
							class="mat-bd-5 relative rounded-lg px-3 py-4"
						>
							<ng-container *ngIf="s.isPrimary">
								<div
									class="absolute bottom-full -mb-3 h-6 rounded-lg bg-purple-500 px-3 text-sm leading-6 text-gray-50"
								>
									{{ 'utils.primary' | translate }}
								</div>
							</ng-container>

							<tg-target-hours-control
								(onCopy)="copySchedule(i)"
								(onDelete)="removeSchedule(i)"
								[defaultName]="'schedules.defaultByUsername' | translate: { name: user.value?.name }"
								[formControl]="ctrl"
							></tg-target-hours-control>
						</div>
					</ng-container>
				</div>
			</mat-tab>
			} @if (contingentVisible$ | async) {
			<mat-tab>
				<ng-template mat-tab-label>
					<div class="flex items-center space-x-2">
						<mat-icon>list_alt</mat-icon>
						<span>{{ 'workspace.timecontingent.name-singular' | translate }}</span>
					</div>
				</ng-template>
				<div class="flex flex-col mt-4">
					@if (isAdmin$.value$ | async) {
					<div
						(click)="$event.preventDefault(); group.controls.employment_date.enabled && openCalPicker()"
						[ngClass]="{ 'cursor-pointer': group.controls.employment_date.enabled }"
						class="flex w-full flex-col"
					>
						<mat-form-field
							appearance="fill"
							class="pointer-events-none"
						>
							<mat-label>{{ 'workspace.employmentDate' | translate }}</mat-label>
							<input
								[disabled]="group.controls.employment_date.disabled"
								[value]="(groupValue.employment_date && (groupValue.employment_date | formatDate)) || null"
								class="!pointer-events-none"
								matInput
							>
							<div matSuffix>
								@if (groupValue.employment_date && group.controls.employment_date.enabled) {
								<button
									(click.native)="group.patchValue({ employment_date: null })"
									class="!pointer-events-auto"
									mat-icon-button
									type="button"
								>
									<mat-icon>close</mat-icon>
								</button>
								}
							</div>
						</mat-form-field>
					</div>
					}
					<div class="flex flex-col relative">
						<div class="mt-4 flex flex-col space-y-3">
							<ng-container *ngTemplateOutlet="timecontingentView"></ng-container>
						</div>
					</div>
				</div>
			</mat-tab>
			}
		</mat-tab-group>
	</form>
</mat-dialog-content>
<div class="dialog-actions">
	<button
		(click)="checkBeforeClose()"
		[disabled]="isLoading.value$ | async"
		mat-button
	>
		<span>{{ (group.pristine ? 'utils.close' : 'utils.cancel') | translate }}</span>
	</button>
	<button
		(click)="saveChanges()"
		[disabled]="group.invalid || group.disabled || (isLoading.value$ | async)"
		color="primary"
		mat-raised-button
	>
		<span
			*ngIf="!(isLoading.value$ | async); else showSaveLoading"
			translate
			>utils.save</span
		>
	</button>
</div>
<ng-template #showSaveLoading>
	<div class="flex flex-row items-center justify-center">
		<mat-progress-spinner
			[diameter]="16"
			[mode]="'indeterminate'"
			[strokeWidth]="2"
			class="-mr-1"
		></mat-progress-spinner>
		&nbsp;
	</div>
</ng-template>
<ng-template #workspaceScheduleInherit>
	<div class="flex flex-col space-y-2">
		<div class="mat-bd-20 mat-typography flex h-12 items-center rounded-lg px-4">
			<div class="flex items-center space-x-2">
				<mat-icon class="flex-shrink-0">info</mat-icon>
				<span>{{ 'schedules.workspaceInheritance' | translate }}</span>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #supervisorTemplate>
	<ng-container
		[formGroup]="group"
		*ngIf="group.getRawValue() as gvalue"
	>
		<div class="mat-bg-input group/card flex flex-col rounded-lg py-2">
			<div class="flex items-center pr-4">
				<div class="flex flex-1 select-none items-center pl-4 gap-1 text-sm font-bold">
					<span translate>workspace.supervisors.name</span>
					<mat-icon
						[matTooltip]="'workspace.user-management.supervisor-tooltip' | translate"
						class="mat-hint cursor-default text-base"
						>info_outline</mat-icon
					>
				</div>
				<button
					(click)="openSupervisorFilterPopover($event, supervisorFilterPopover)"
					[disabled]="group.disabled || (isLoading.value$ | async)"
					[matTooltip]="'workspace.supervisors.add' | translate"
					[satPopoverAnchor]="supervisorFilterPopover"
					mat-icon-button
					type="button"
				>
					<mat-icon>person_add_alt_1</mat-icon>
				</button>
			</div>
			@if (gvalue.supervisors?.length && gvalue.supervisors | userRef; as supervisors) { @for (s of supervisors;
			track s.id) {
			<div class="group/item flex h-12 items-center space-x-2 px-4 pb-4">
				<app-user-avatar
					[userId]="s.id"
					class="rounded-circle mr-2 flex-shrink-0"
					size="32px"
				></app-user-avatar>
				<div class="flex flex-auto flex-col items-start justify-center truncate">
					<div
						class="w-full truncate transition-transform duration-200 translate-y-3 group-hover/item:translate-y-0"
					>
						{{ s.name }}
					</div>
					<div
						class="mat-hint w-full truncate opacity-0 -translate-y-1 group-hover/item:opacity-100 group-hover/item:translate-y-0 transition-all duration-200"
					>
						{{ s.email }}
					</div>
				</div>
				@if (!group.disabled) {
				<button
					(click)="removeSupervisor(s.id)"
					class="opacity-0 group-hover/card:opacity-30 group-hover/item:opacity-100"
					mat-icon-button
					type="button"
				>
					<mat-icon>close</mat-icon>
				</button>
				}
			</div>
			} } @else {
			<div
				class="mat-hint px-4 pb-3 text-sm2"
				translate
			>
				workspace.supervisors.none-assigned
			</div>
			}
		</div>
		<tg-employee-filter-popover
			(itemsClose)="onSupervisorFilterClose($event)"
			[excludeIds]="[userId]"
			[hideSubordinateIcon]="true"
			[selectedItems]="popoverSupervisorIds"
			#supervisorFilterPopover
			style="display: contents"
		></tg-employee-filter-popover>
	</ng-container>
</ng-template>
<ng-template #subordinateTemplate>
	<ng-container
		[formGroup]="group"
		*ngIf="group.getRawValue() as gvalue"
	>
		<div class="mat-bg-input group/card flex flex-col rounded-lg py-2">
			<div class="flex items-center pr-4">
				<div class="flex flex-1 select-none items-center pl-4 gap-1 text-sm font-bold">
					<span translate>workspace.supervisors.subordinates</span>
					<mat-icon
						[matTooltip]="'workspace.user-management.direct-report-tooltip' | translate"
						class="mat-hint cursor-default text-base"
						>info_outline</mat-icon
					>
				</div>
				<button
					(click)="openSubordinateFilterPopover($event, subordinateFilterPopover)"
					[disabled]="group.disabled || (isLoading.value$ | async)"
					[matTooltip]="'workspace.subordinates.add' | translate"
					[satPopoverAnchor]="subordinateFilterPopover"
					mat-icon-button
					type="button"
				>
					<mat-icon>person_add_alt_1</mat-icon>
				</button>
			</div>
			@if (gvalue.subordinates?.length && gvalue.subordinates | userRef; as entries) { @for (s of entries; track
			s.id) {
			<div class="group/item flex h-12 items-center space-x-2 px-4 pb-4">
				<app-user-avatar
					[userId]="s.id"
					class="rounded-circle mr-2 flex-shrink-0"
					size="32px"
				></app-user-avatar>
				<div class="flex flex-auto flex-col items-start justify-center truncate">
					<div
						class="w-full truncate transition-transform duration-200 translate-y-3 group-hover/item:translate-y-0"
					>
						{{ s.name }}
					</div>
					<div
						class="mat-hint w-full truncate opacity-0 -translate-y-1 group-hover/item:opacity-100 group-hover/item:translate-y-0 transition-all duration-200"
					>
						{{ s.email }}
					</div>
				</div>
				@if (!group.disabled) {
				<button
					(click)="removeSubordinate(s.id)"
					class="opacity-0 group-hover/card:opacity-30 group-hover/item:opacity-100"
					mat-icon-button
					type="button"
				>
					<mat-icon>close</mat-icon>
				</button>
				}
			</div>
			} } @else {
			<div
				class="mat-hint px-4 pb-3 text-sm2"
				translate
			>
				workspace.subordinates.none-assigned
			</div>
			}
		</div>
		<tg-employee-filter-popover
			(itemsClose)="onSubordinateFilterClose($event)"
			[excludeIds]="[userId]"
			[hideSubordinateIcon]="true"
			[selectedItems]="popoverSubordinateIds"
			#subordinateFilterPopover
			style="display: contents"
		></tg-employee-filter-popover>
	</ng-container>
</ng-template>
<ng-template #timecontingentView>
	<app-loader
		[isActive]="timecontingent$timesLoading.value$ | async"
		customBackColor="hsl(var(--dialog))"
		enableCircle
	></app-loader>
	@if (timecontingent$times.value$ | async; as tc) {
	<div
		*ngIf="!groupValue.employment_date || group.controls.employment_date.dirty"
		class="absolute inset-0 z-10 overflow-hidden rounded-md flex flex-col items-center justify-center"
	>
		<div class="absolute inset-0 mat-bg-5 backdrop-blur mask-to-t"></div>
		@if (!groupValue.employment_date) {
		<span
			*ngIf="!groupValue.employment_date"
			class="mx-4 relative z-10"
		>
			{{ 'workspace.timecontingent.employmentDateRequirement' | translate }}</span
		>} @else if (group.controls.employment_date.dirty) {<span class="mx-4 relative z-10">
			{{ 'workspace.timecontingent.newEmplaymentDateSaveRefresh' | translate }}</span
		>}
	</div>
	<div class="flex flex-col gap-6">
		@if (timecontingentState.value$ | async; as cstate) {
		<div class="alert alert-warning alert-tight rounded py-2">
			{{ 'workspace.timecontingent.processing' | translate }}
		</div>
		}
		<div class="grid grid-cols-1 md:grid-cols-3 gap-3 justify-between">
			<div class="grid grid-rows-[20px_20px] gap-1 items-center rounded-lg mat-bd-5 mat-bg-3 shadow p-2.5">
				<span class="text-sm text-muted">+/- {{ 'workspace.schedule.individual' | translate }}</span>
				@if (tc.enabled) {
				<span
					[ngClass]="tc.workinghours < 0.0 ? 'text-warn' : tc.workinghours > 0.0 ? 'text-success' : ''"
					class="font-semibold"
					>{{
						tc.workinghours | parseMsAsDuration: false : true
					}}</span
				>
				} @else {<span>-</span>}
			</div>
			<div class="grid grid-rows-[20px_20px] gap-1 items-center rounded-lg mat-bd-5 mat-bg-3 shadow p-2.5">
				<span class="text-sm text-muted">+/- {{ 'workspace.timecontingent.creditdeduct' | translate }}</span>
				@if (tc.enabled) {
				<span
					[ngClass]="tc.credit < 0.0 ? 'text-warn' : tc.credit > 0.0 ? 'text-success' : ''"
					class="font-semibold"
					>{{
						tc.credit | parseMsAsDuration: false : true
					}}</span
				>
				} @else {<span>-</span>}
			</div>
			<div class="grid grid-rows-[20px_20px] gap-1 items-center rounded-lg mat-bd-5 mat-bg-3 shadow p-2.5">
				<span class="text-sm text-muted">+/- {{ 'workspace.timecontingent.account' | translate }}</span>
				@if (tc.enabled) {
				<span
					[ngClass]="tc.contingent < 0.0 ? 'text-warn' : tc.contingent > 0.0 ? 'text-success' : ''"
					class="font-semibold"
					>{{
						tc.contingent | parseMsAsDuration: false : true
					}}</span
				>
				} @else {<span>-</span>}
			</div>
		</div>
		<div class="flex flex-col gap-1">
			<h1 class="text-sm text-muted-foreground">{{ 'workspace.timecontingent.creditdeduct' | translate }}</h1>
			<div
				[ngClass]="{ 'justify-center items-center h-[368px]': !tc.credits?.length }"
				class="rounded-lg mat-bd-5 flex flex-col"
			>
				@if (tc.credits?.length) {
				<div
					class="h-12 font-bold text-sm grid grid-cols-[100px_120px_64px_1fr_100px] gap-2 items-center px-4 mat-bd-b-5 flex-shrink-0"
				>
					<div>Type</div>
					<div>Date</div>
					<div>Author</div>
					<div>Comment</div>
					<div>+/-</div>
				</div>
				<div class="flex h-[300px] flex-col overflow-y-auto">
					@for (c of tc.credits; track $index) {
					<div
						(click)="openCreditDialog(c, $index)"
						class="h-12 grid grid-cols-[100px_120px_64px_1fr_100px] gap-2 items-center px-4 cursor-pointer hover:mat-bg-5 flex-shrink-0"
					>
						<div>{{ c.type }}</div>
						<div>{{ c.date | formatDate: 'date' }}</div>
						<app-user-avatar
							[matTooltip]="c.user.name | parseName"
							[userId]="c.user.id"
							class="rounded-full"
							size="40px"
						></app-user-avatar>
						<div class="line-clamp-2">{{ c.description }}</div>
						<div [ngClass]="{ 'text-warn': c.type === 'deduct', 'text-success': c.type === 'credit' }">
							{{ c.type === 'credit' ? '+' : c.type === 'deduct' ? '-' : '' }}
							{{ c.value | parseMsAsDuration }}
						</div>
					</div>
					}
				</div>
				<div class="flex justify-end px-4 pb-4 pt-2 mat-bd-t-5">
					<button
						(click)="openCreditDialog()"
						[ngClass]="!tc.enabled && 'opacity-50'"
						mat-stroked-button
					>
						{{ 'workspace.timecontingent.add-credit' | translate }}
					</button>
				</div>
				} @else {
				<button
					(click)="openCreditDialog()"
					[ngClass]="!tc.enabled && 'opacity-50'"
					mat-stroked-button
				>
					{{ 'workspace.timecontingent.add-credit' | translate }}
				</button>
				}
			</div>
		</div>
	</div>
	}
</ng-template>
<ng-template #groupsTemplate>
	<!-- Groups Section -->
	<div class="mat-bg-input group/card flex flex-col rounded-lg py-2">
		<div class="flex items-center pr-4">
			<div class="flex flex-1 select-none items-center pl-4 gap-1 text-sm font-bold">
				<span translate>workspace.groups.plural</span>
				<mat-icon
					[matTooltip]="'workspace.user-management.groups-tooltip' | translate"
					class="mat-hint cursor-default text-base"
					>info_outline</mat-icon
				>
			</div>
			<button
				(click)="openGroupFilterPopover($event, groupsFilterPopover)"
				[disabled]="group.disabled || (isLoading.value$ | async)"
				[matTooltip]="'workspace.groups.assign-groups' | translate"
				[satPopoverAnchor]="groupsFilterPopover"
				mat-icon-button
				type="button"
			>
				<mat-icon>group_add</mat-icon>
			</button>
		</div>
		<ng-container *ngIf="getUserGroupEntities() as groups">
			@if (groups.length > 0) { @for (userGroup of groups; track userGroup.id) {
			<div class="group/item flex h-10 min-w-0 items-center space-x-2 px-4">
				<mat-icon class="flex-shrink-0 text-lg">group</mat-icon>
				<div
					[matTooltip]="userGroup.name | groupTranslate: userGroup.id"
					[matTooltipDisabled]="groupName.scrollWidth <= groupName.clientWidth"
					#groupName
					class="w-full mat-truncate"
				>
					{{ userGroup.name | groupTranslate: userGroup.id }}
				</div>
				@if (!group.disabled) {
				<button
					(click)="removeGroup(userGroup.id)"
					class="flex-shrink-0 opacity-0 group-hover/card:opacity-30 group-hover/item:opacity-100"
					mat-icon-button
					type="button"
				>
					<mat-icon>close</mat-icon>
				</button>
				}
			</div>
			} } @else {
			<div
				class="mat-hint px-4 pb-3 text-sm2"
				translate
			>
				workspace.groups.none-assigned
			</div>
			}
		</ng-container>
	</div>
	<tg-groups-filter-popover
		(itemsClose)="onGroupFilterClose($event)"
		[excludeSystemGroups]="true"
		[selectedItems]="popoverGroupIds"
		#groupsFilterPopover
		style="display: contents"
	></tg-groups-filter-popover>
</ng-template>
